unit assets.settings.budgetownfleet.maintenance;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, WEBLib.DBCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.DB, WEBLib.Buttons, XData.Web.Client;

type
  TfrmOwnFleetBudgetMaintenance = class(TForm)
    WebLabel1: TLabel;
    sbBottom: TScrollBox;
    sbMain: TScrollBox;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    eyear: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    qBudgets: TXDataWebDataSet;
    dsBudget: TDataSource;
    qMonths: TXDataWebDataSet;
    qCostGroups: TXDataWebDataSet;
    dsCostGroups: TDataSource;
    dsMonths: TDataSource;
    lmonth: TDBLookupComboBox;
    lCostCenter: TDBLookupComboBox;
    btnCancel: TSpeedButton;
    btnSave: TSpeedButton;
    wcInfo: TXDataWebClient;
    WebMessageDlg1: TMessageDlg;
    procedure WebFormShow(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnSaveClick(Sender: TObject);
    procedure qBudgetsAfterOpen(DataSet: TDataSet);
  private
    { Private declarations }
  public
    { Public declarations }
    bInsert,
    bSave : Boolean;
    iYear,
    iMonth,
    iCost : Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmOwnFleetBudgetMaintenance: TfrmOwnFleetBudgetMaintenance;

implementation

{$R *.dfm}

uses
  stfmssystem.connection;

procedure TfrmOwnFleetBudgetMaintenance.btnCancelClick(Sender: TObject);
begin
  bSave := False;
  qBudgets.Cancel;
  Close;
end;

procedure TfrmOwnFleetBudgetMaintenance.btnSaveClick(Sender: TObject);
  var
    sSQL : String;
    bPrimary : Boolean;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    try
      bPrimary := JS.toBoolean(JS.ToObject(Response.Result)['value']);
      if bPrimary then
        //DisplayMessageBox('Error','Information Already Exists', ['Ok'])
      else
        begin
          qBudgets.Post;
          qBudgets.ApplyUpdates;
          bSave := True;
          Close;
        end;
    except
      On E:Exception do
        begin
          //MessageDlg.
          MessageDlg(E.Message, WEBLib.Dialogs.mtError, []);
        end;
    end;
  end;
begin
  bSave := False;
  if (Trim(eYear.Text) <> '') then
    begin
      if (Trim(lMonth.DisplayText) <> '') then
        begin
          if (Trim(lCostCenter.DisplayText) <> '') then
            begin
              if bInsert then
                begin
                  sSQL := 'select * from budgets_ownfleet where monthno = ''' + lMonth.Value + ''' and yearno = ''' + eYear.Text + ''' and costcode = ''' + lCostCenter.Value + '''';
                  wcInfo.RawInvoke('IcommonService.ValidatePrimaryKey', [sSQL], @OnResult);
                end;
            end
          else
            begin
              MessageDlg('Please Select Cost Center', WEBLib.Dialogs.mtError, []);
            end;
        end
      else
        begin
          MessageDlg('Please Select Month', WEBLib.Dialogs.mtError, []);
        end;
    end
  else
    begin
      MessageDlg('Please Select Year', WEBLib.Dialogs.mtError, []);
    end;
end;

procedure TfrmOwnFleetBudgetMaintenance.qBudgetsAfterOpen(DataSet: TDataSet);
begin

  if bInsert then
    qBudgets.Append
  else
    qBudgets.Edit;
end;

procedure TfrmOwnFleetBudgetMaintenance.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := caFree;
end;

procedure TfrmOwnFleetBudgetMaintenance.WebFormShow(Sender: TObject);
begin
  if not qMonths.Active then
    qMonths.Load;
  if not qCostGroups.Active then
    qCostGroups.Load;
  qBudgets.Close;
  if bInsert then
    begin
      qBudgets.Load;
    end
  else
    begin
      qBudgets.QueryString := '$filter=yearno eq ' + quotedstr(IntToStr(iYear)) +
                              ' and monthno eq ' + quotedstr(IntToStr(iMonth)) +
                              ' and costcode eq ' + quotedstr(IntToStr(iCost));
      qBudgets.Load;
    end;
end;

procedure TfrmOwnFleetBudgetMaintenance.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  sbBottom := TScrollBox.Create(Self);
  btnCancel := TSpeedButton.Create(Self);
  btnSave := TSpeedButton.Create(Self);
  sbMain := TScrollBox.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  eyear := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  lmonth := TDBLookupComboBox.Create(Self);
  lCostCenter := TDBLookupComboBox.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  qBudgets := TXDataWebDataSet.Create(Self);
  dsBudget := TDataSource.Create(Self);
  qMonths := TXDataWebDataSet.Create(Self);
  qCostGroups := TXDataWebDataSet.Create(Self);
  dsCostGroups := TDataSource.Create(Self);
  dsMonths := TDataSource.Create(Self);
  wcInfo := TXDataWebClient.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  sbBottom.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  sbMain.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  eyear.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  lmonth.BeforeLoadDFMValues;
  lCostCenter.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  qBudgets.BeforeLoadDFMValues;
  dsBudget.BeforeLoadDFMValues;
  qMonths.BeforeLoadDFMValues;
  qCostGroups.BeforeLoadDFMValues;
  dsCostGroups.BeforeLoadDFMValues;
  dsMonths.BeforeLoadDFMValues;
  wcInfo.BeforeLoadDFMValues;
  try
    Name := 'frmOwnFleetBudgetMaintenance';
    Width := 534;
    Height := 314;
    Caption := 'Own Fleet - Budget Maintenance';
    Color := clSilver;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 534;
    WebLabel1.Height := 33;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Own Fleet - Budget Maintenance';
    WebLabel1.Color := clSilver;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    sbBottom.SetParentComponent(Self);
    sbBottom.Name := 'sbBottom';
    sbBottom.AlignWithMargins := True;
    sbBottom.Left := 3;
    sbBottom.Top := 251;
    sbBottom.Width := 528;
    sbBottom.Height := 60;
    sbBottom.Align := alBottom;
    sbBottom.AutoScroll := True;
    sbBottom.BorderStyle := bsSingle;
    sbBottom.ChildOrder := 1;
    sbBottom.Color := clSilver;
    btnCancel.SetParentComponent(sbBottom);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 404;
    btnCancel.Top := 3;
    btnCancel.Width := 100;
    btnCancel.Height := 40;
    btnCancel.Anchors := [akTop,akRight];
    btnCancel.Caption := 'Cancel';
    btnCancel.Color := clGold;
    btnCancel.Font.Charset := DEFAULT_CHARSET;
    btnCancel.Font.Color := clWindowText;
    btnCancel.Font.Height := -12;
    btnCancel.Font.Name := 'Segoe UI';
    btnCancel.Font.Style := [fsBold];
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.ParentFont := False;
    btnCancel.TabOrder := 0;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    btnSave.SetParentComponent(sbBottom);
    btnSave.Name := 'btnSave';
    btnSave.Left := 298;
    btnSave.Top := 3;
    btnSave.Width := 100;
    btnSave.Height := 40;
    btnSave.Anchors := [akTop,akRight];
    btnSave.Caption := 'Save';
    btnSave.Color := clLightseagreen;
    btnSave.Font.Charset := DEFAULT_CHARSET;
    btnSave.Font.Color := clWindowText;
    btnSave.Font.Height := -12;
    btnSave.Font.Name := 'Segoe UI';
    btnSave.Font.Style := [fsBold];
    btnSave.HeightPercent := 100.000000000000000000;
    btnSave.ParentFont := False;
    btnSave.TabOrder := 1;
    btnSave.WidthPercent := 100.000000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    sbMain.SetParentComponent(Self);
    sbMain.Name := 'sbMain';
    sbMain.AlignWithMargins := True;
    sbMain.Left := 3;
    sbMain.Top := 36;
    sbMain.Width := 528;
    sbMain.Height := 209;
    sbMain.Align := alClient;
    sbMain.AutoScroll := True;
    sbMain.BorderStyle := bsSingle;
    sbMain.ChildOrder := 2;
    sbMain.Color := clSilver;
    WebLabel2.SetParentComponent(sbMain);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 24;
    WebLabel2.Top := 24;
    WebLabel2.Width := 31;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Year : ';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(sbMain);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 184;
    WebLabel3.Top := 24;
    WebLabel3.Width := 45;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Month : ';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(sbMain);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 352;
    WebLabel4.Top := 24;
    WebLabel4.Width := 71;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Cost Center : ';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(sbMain);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 24;
    WebLabel5.Top := 80;
    WebLabel5.Width := 54;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Revenue : ';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(sbMain);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 184;
    WebLabel6.Top := 80;
    WebLabel6.Width := 48;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Surplus : ';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(sbMain);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 24;
    WebLabel7.Top := 136;
    WebLabel7.Width := 103;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Day Average Total : ';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(sbMain);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 184;
    WebLabel8.Top := 136;
    WebLabel8.Width := 126;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Day Avg First Warning : ';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(sbMain);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 352;
    WebLabel9.Top := 136;
    WebLabel9.Width := 143;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Day Avg Second Warning : ';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    eyear.SetParentComponent(sbMain);
    eyear.Name := 'eyear';
    eyear.Left := 24;
    eyear.Top := 45;
    eyear.Width := 74;
    eyear.Height := 22;
    eyear.ChildOrder := 8;
    eyear.HeightPercent := 100.000000000000000000;
    eyear.Text := 'eyear';
    eyear.WidthPercent := 100.000000000000000000;
    eyear.DataField := 'yearno';
    eyear.DataSource := dsBudget;
    WebDBEdit3.SetParentComponent(sbMain);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 24;
    WebDBEdit3.Top := 101;
    WebDBEdit3.Width := 129;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 10;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'revenuetotal';
    WebDBEdit3.DataSource := dsBudget;
    WebDBEdit4.SetParentComponent(sbMain);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 184;
    WebDBEdit4.Top := 101;
    WebDBEdit4.Width := 121;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 11;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'surplustotal';
    WebDBEdit4.DataSource := dsBudget;
    WebDBEdit5.SetParentComponent(sbMain);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 24;
    WebDBEdit5.Top := 157;
    WebDBEdit5.Width := 121;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 12;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'dayaveragetotal';
    WebDBEdit5.DataSource := dsBudget;
    WebDBEdit6.SetParentComponent(sbMain);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 184;
    WebDBEdit6.Top := 157;
    WebDBEdit6.Width := 121;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 13;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit6';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'dayfirstwarning';
    WebDBEdit6.DataSource := dsBudget;
    WebDBEdit7.SetParentComponent(sbMain);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 352;
    WebDBEdit7.Top := 157;
    WebDBEdit7.Width := 121;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 14;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit7';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'daysecondwarning';
    WebDBEdit7.DataSource := dsBudget;
    lmonth.SetParentComponent(sbMain);
    lmonth.Name := 'lmonth';
    lmonth.Left := 184;
    lmonth.Top := 45;
    lmonth.Width := 145;
    lmonth.Height := 22;
    lmonth.HeightPercent := 100.000000000000000000;
    lmonth.WidthPercent := 100.000000000000000000;
    lmonth.DataField := 'monthno';
    lmonth.DataSource := dsBudget;
    lmonth.KeyField := 'monthno';
    lmonth.ListField := 'monthname';
    lmonth.ListSource := dsMonths;
    lCostCenter.SetParentComponent(sbMain);
    lCostCenter.Name := 'lCostCenter';
    lCostCenter.Left := 352;
    lCostCenter.Top := 45;
    lCostCenter.Width := 145;
    lCostCenter.Height := 22;
    lCostCenter.HeightPercent := 100.000000000000000000;
    lCostCenter.WidthPercent := 100.000000000000000000;
    lCostCenter.DataField := 'costcode';
    lCostCenter.DataSource := dsBudget;
    lCostCenter.KeyField := 'CODE';
    lCostCenter.ListField := 'DESCRIPTION';
    lCostCenter.ListSource := dsCostGroups;
    WebMessageDlg1.SetParentComponent(sbMain);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 320;
    WebMessageDlg1.Top := 144;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [];
    WebMessageDlg1.Opacity := 0.200000000000000000;
    qBudgets.SetParentComponent(Self);
    qBudgets.Name := 'qBudgets';
    qBudgets.AfterOpen := qBudgetsAfterOpen;
    qBudgets.EntitySetName := 'budgets_ownfleet';
    qBudgets.Connection := dmData.dbConnect;
    qBudgets.Left := 315;
    qBudgets.Top := 100;
    dsBudget.SetParentComponent(Self);
    dsBudget.Name := 'dsBudget';
    dsBudget.AutoEdit := False;
    dsBudget.DataSet := qBudgets;
    dsBudget.Left := 379;
    dsBudget.Top := 108;
    qMonths.SetParentComponent(Self);
    qMonths.Name := 'qMonths';
    qMonths.EntitySetName := 'monthsinfo';
    qMonths.Connection := dmData.dbConnect;
    qMonths.Left := 147;
    qMonths.Top := 44;
    qCostGroups.SetParentComponent(Self);
    qCostGroups.Name := 'qCostGroups';
    qCostGroups.EntitySetName := 'costgroups';
    qCostGroups.Connection := dmData.dbConnect;
    qCostGroups.QueryString := '$Orderby=description ';
    qCostGroups.Left := 459;
    qCostGroups.Top := 84;
    dsCostGroups.SetParentComponent(Self);
    dsCostGroups.Name := 'dsCostGroups';
    dsCostGroups.AutoEdit := False;
    dsCostGroups.DataSet := qCostGroups;
    dsCostGroups.Left := 515;
    dsCostGroups.Top := 92;
    dsMonths.SetParentComponent(Self);
    dsMonths.Name := 'dsMonths';
    dsMonths.AutoEdit := False;
    dsMonths.DataSet := qMonths;
    dsMonths.Left := 147;
    dsMonths.Top := 76;
    wcInfo.SetParentComponent(Self);
    wcInfo.Name := 'wcInfo';
    wcInfo.Connection := dmData.dbConnect;
    wcInfo.Left := 163;
    wcInfo.Top := 212;
  finally
    WebLabel1.AfterLoadDFMValues;
    sbBottom.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    sbMain.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    eyear.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    lmonth.AfterLoadDFMValues;
    lCostCenter.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    qBudgets.AfterLoadDFMValues;
    dsBudget.AfterLoadDFMValues;
    qMonths.AfterLoadDFMValues;
    qCostGroups.AfterLoadDFMValues;
    dsCostGroups.AfterLoadDFMValues;
    dsMonths.AfterLoadDFMValues;
    wcInfo.AfterLoadDFMValues;
  end;
end;

end.